"use strict";
angular.module("internal.exams").controller("InternalExamViews", ["$scope",
    "Queries",
    function ($scope, Queries) {
        $scope.loading = true;
        Queries.get('internal.exams.sessions').then(function (queries) {
            $scope.queries = queries;
            $scope.loading = false;
        });
        $scope.columns = [{
            label: "Name",
            field: "name",
            link: {
                state: "internal.exams.administrative.internalview.details",
                params: [{
                    name: "queryId",
                    field: "id"
                }]
            }
        }, {
            label: "Description",
            field: "description"
        }, {
            label: "Page",
            field: "query_page.name"
        }, {
            label: "Last Modified",
            field: "modifiedon",
            type: "datetime"
        }, {
            label: "Modified By",
            field: "modifiedby"
        }];
    }]);